// extracted by mini-css-extract-plugin
module.exports = {"jobPositions":"TeamsJobPositions_jobPositions__2Z0ba","jobPositions__image":"TeamsJobPositions_jobPositions__image__b5Ukm"};